import { render, staticRenderFns } from "./viewingDisciplinePreview.vue?vue&type=template&id=052acc0a"
import script from "./viewingDisciplinePreview.vue?vue&type=script&lang=js"
export * from "./viewingDisciplinePreview.vue?vue&type=script&lang=js"
import style0 from "./viewingDisciplinePreview.vue?vue&type=style&index=0&id=052acc0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports